import Big from "big.js";
import { CheckboxGroupOption } from "../../Unknown/CheckboxGroup";

type AddOn = {
  id: string;
  name: string;
  price: number;
  allowMultiplePurchases?: boolean;
};

const parseAddOn = ({
  addOn,
  currencyCode,
  checked,
  offeringsCount = 1,
  quantity = 1,
  onQuantityChange,
  disabled,
}: {
  addOn: AddOn;
  currencyCode: string;
  checked: boolean;
  offeringsCount?: number;
  quantity?: number;
  onQuantityChange?: (quantity: number) => void;
  disabled?: boolean;
}): CheckboxGroupOption => {
  const { id, name, price } = addOn;

  const totalPrice = Big(price)
    .times(offeringsCount)
    .times(quantity)
    .toNumber();

  return {
    value: id,
    label: name,
    price: totalPrice,
    currencyCode,
    checked,
    allowMultiplePurchases: addOn.allowMultiplePurchases,
    quantity,
    onQuantityChange,
    disabled,
  };
};

export default parseAddOn;
